import type { InfiniteQueryConfigOptions } from "@reduxjs/toolkit/query/react"
import type { PageParam, Pagination } from "./model"

type HasPagination = {
  pagination: Pagination
}

export default <
  TResult extends HasPagination,
  TQueryArg,
>(): InfiniteQueryConfigOptions<TResult, PageParam, TQueryArg> => ({
  initialPageParam: {
    page: 1,
    pageCount: 99, // TODO: ??
  },
  getNextPageParam: (lastPage, _allPages, lastPageParam) => {
    const nextPage = lastPageParam.page + 1

    return nextPage > lastPage.pagination.pageCount
      ? undefined
      : {
          ...lastPageParam,
          page: nextPage,
        }
  },
  getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => {
    const prevPage = firstPageParam.page - 1

    return prevPage < 1
      ? undefined
      : {
          ...firstPageParam,
          page: prevPage,
        }
  },
})
